"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawableLineCreateBinding = drawableLineCreateBinding;
var mobx_1 = require("mobx");
var label_draw_svg_1 = require("../drawable/label.draw.svg");
var util_1 = require("../util");
var START_DELTA = { x: -100, y: 0 };
var END_DELTA = { x: 100, y: 0 };
var LABEL_DELTA = { x: 150, y: 150 };
function getLabelPoint(dc, center) {
    var uiScale = dc.state.scale;
    return (0, util_1.movePoint)(center, LABEL_DELTA, dc.capture.resolution, {
        width: label_draw_svg_1.LabelSVGDraw.Size.width * uiScale,
        height: label_draw_svg_1.LabelSVGDraw.height(1) * uiScale
    });
}
function createLineAt(dc, center) {
    var drawableId = dc.drawState.Mutator.create('line');
    var drawable = dc.drawState.getDrawable(drawableId);
    var labelPoint = getLabelPoint(dc, center);
    var startPoint = (0, util_1.movePoint)(center, START_DELTA, dc.capture.resolution);
    var endPoint = (0, util_1.movePoint)(center, END_DELTA, dc.capture.resolution);
    drawable.Mutator.init(startPoint, endPoint, labelPoint);
    dc.state.setSelected(drawable.start.id, null);
    // Ensure that the base / base offset marker does not have any insight flags
    // This should not trigger as we don't support insight base & base offsets made by the back end yet
    if (dc.drawState.insightBase) {
        dc.drawState.insightBase.approveInsightFlag();
    }
    if (dc.drawState.insightBaseOffset) {
        dc.drawState.insightBaseOffset.approveInsightFlag();
    }
}
function drawableLineCreateBinding(dc, evt) {
    if (evt.drawableId == null) {
        (0, mobx_1.runInAction)(function () { return createLineAt(dc, evt.center); });
        return;
    }
    if (evt.$event != null) {
        evt.$event.preventDefault();
    }
}
//# sourceMappingURL=line.create.binding.js.map